import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getContractors = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/contractors`);
    return response.data;
  } catch (error) {
    console.error('Error fetching contractors:', error.response?.data || error);
    throw error;
  }
};

export const getContractorById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/contractors/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching contractor:', error.response?.data || error);
    throw error;
  }
};

export const createContractor = async (contractorData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/contractors`, contractorData);
    return response.data;
  } catch (error) {
    console.error('Error creating contractor:', error.response?.data || error);
    throw error;
  }
};

export const updateContractor = async (id, contractorData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/contractors/${id}`, contractorData);
    return response.data;
  } catch (error) {
    console.error('Error updating contractor:', error.response?.data || error);
    throw error;
  }
};

export const deleteContractor = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/contractors/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting contractor:', error.response?.data || error);
    throw error;
  }
};
